export class DriverId {
  id: number
  constructor(
    id: number
  ){
    this.id = id;
  }
}